import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
    IApiResponse,
    IPaginatedApiResponse,
} from "../../../utils/types/api-response";
import {
    IBill,
    IBillsFilters,
    IPaymentCardsResponse,
} from "../types/billing.types";
import {
    fetchPaymentCards,
    getOutstandingBills,
} from "../services/billing.services";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";

export function useFetchPaymentCards(enabled = true) {
    return useQuery<IPaymentCardsResponse, AxiosError<IPaymentCardsResponse>>({
        queryKey: ["payment-cards"],
        queryFn: () => fetchPaymentCards(),
        enabled,
    });
}

export function useGetOutstandingBills(filters: IBillsFilters) {
    return useQuery<
        IPaginatedApiResponse<IBill[]>,
        AxiosError<IApiResponse<IBill[]>>
    >({
        queryKey: [
            "outstanding-bills",
            handleRemoveEmptyParamFromQueryParams(filters),
        ],
        queryFn: () => getOutstandingBills(filters),
    });
}
